import React from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';

const StyledModal = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #fff;
  opacity: 0;
  height: 0;
  width: 100vw;
  overflow: hidden;

  ${({ isVisible }) =>
    isVisible &&
    css`
      height: 100vh;
      opacity: 1;
    `};
`;

const GlobalStyle = createGlobalStyle`
  body {
    overflow: hidden;
    touch-action: none;
    overscroll-behavior: none;
  }
`;

export const Modal = ({
  children,
  isVisible,
}: {
  children: React.ReactNode;
  isVisible: boolean;
}) => (
  <StyledModal isVisible={isVisible}>
    {isVisible && (
      <>
        <GlobalStyle />
        {children}
      </>
    )}
  </StyledModal>
);
